import { CardInfo } from './Card';
export default CardInfo;